import DashboardRoute from '@/views/dashboard/route'
import GroupJoinRoute from '@/views/groupjoin/route'
import Home from '../views/Home.vue'
import Loading from '../views/Loading.vue'
import RegistrationRoute from '@/views/registration/route'
import LinkRoute from '@/views/link/route.js'
import TryoutRoute from '@/views/tryout/route'
import PrivacyPolicy from '@/views/PrivacyPolicy'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    }, {
        path: '/loading',
        name: 'loading',
        component: Loading,
        meta: {
            title: 'Loading'
        }
    }, {
        path: '/privacy-policy',
        name: 'privacyPolicy',
        component: PrivacyPolicy
    },
    ...RegistrationRoute,
    ...DashboardRoute,
    ...TryoutRoute,
    ...GroupJoinRoute,
    ...LinkRoute,
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
